export function isBundleTemplate(template) {
    return template.type !== 'nom';
}
